import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

const EMPTY = { agents: [], apps: [] };

/**
 * useSidebarItems — the CURRENT project's apps + agents in ONE request
 * (GET /workspace/sidebar?projectId=<id>). Per-project: the sidebar shows this
 * project's items and changes when you switch projects. Each row carries its
 * projectId so the sidebar links to the right project.
 */
export const useSidebarItems = (projectId) =>
  useQuery({
    queryKey: ['workspace', 'sidebar', projectId],
    queryFn: async () => {
      const data = await api.get(`/workspace/sidebar?projectId=${encodeURIComponent(projectId)}`);
      return {
        agents: Array.isArray(data?.agents) ? data.agents : [],
        apps: Array.isArray(data?.apps) ? data.apps : [],
      };
    },
    enabled: !!projectId,
    staleTime: 60_000,
    placeholderData: EMPTY,
  });

export default useSidebarItems;
